import { CITIES, PROVINCIAS, TIPO_RESPONSABLE } from 'Constants'

export const INF_GRAL_FIELDS = (data, handleChange, edit, permissions) => {
  const normalizeText = (val) => {
    if (val === null || val === undefined) return ''
    return String(val)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toUpperCase()
  }

  const provinciaId = PROVINCIAS.find(
    (provincia) => provincia.provincia === data.provincia?.trim()
  )?.id
  const filteredCities = CITIES.filter((city) => city.provincia_id === provinciaId)
    .sort((a, b) => a.localidad.localeCompare(b.localidad))
    .map((city) => ({
      ...city,
      displayName: `${city.localidad} (CP: ${city.cp})`,
    }))
  const tipoResponsableValue = (() => {
    const raw = data.tipo_responsable
    if (raw === null || raw === undefined) return raw
    if (typeof raw === 'number') return raw
    const asNumber = Number(String(raw).trim())
    if (!Number.isNaN(asNumber) && TIPO_RESPONSABLE.some((t) => t.value === asNumber))
      return asNumber
    const matchByName = TIPO_RESPONSABLE.find((t) => normalizeText(t.name) === normalizeText(raw))
    return matchByName ? matchByName.value : raw
  })()
  const razonSocialValue = data.nombre ?? data.razon_social ?? ''

  return [
    {
      class: 'textfield',
      name: 'origen',
      label: 'Origen',
      value: data.origen,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'id',
      label: 'Nº cliente',
      value: data.id,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'cond_iva',
      label: 'Nacionalidad',
      value: data.cond_iva === 91 ? 'EXTRANJERO' : 'LOCAL',
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      type: 'text',
      name: 'cuit',
      label: 'CUIT/CUIL/DNI',
      value: data.cuit,
      sm: 6,
      xs: 12,
      disabled: permissions.allowEdit ? !edit : true,
      onChange: (e) => {
        handleChange('cuit', e.target.value)
      },
    },
    {
      class: 'textfield',
      name: 'nombre',
      label: 'Razón social',
      value: razonSocialValue,
      disabled: permissions.allowEdit ? !edit : true,
      sm: 6,
      xs: 12,
      onChange: (e) => {
        handleChange('nombre', e.target.value)
      },
    },
    {
      class: 'textfield',
      label: 'Nombre comercial',
      name: 'denominacion',
      value: data.denominacion,
      sm: 6,
      xs: 12,
      disabled: !edit,
      onChange: (e) => {
        handleChange('denominacion', e.target.value)
      },
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'tipo_responsable',
      label: 'Tipo responsable',
      optionValue: 'value',
      options: TIPO_RESPONSABLE,
      optionLabel: `options["name"]`,
      value: tipoResponsableValue,
      disabled: !edit,
      onChange: (e) => handleChange('tipo_responsable', e.value),
    },
    {
      class: 'textfield',
      name: 'estado',
      label: 'Estado',
      value: data.estado,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'provincia',
      label: 'Provincia',
      optionValue: 'provincia',
      options: PROVINCIAS,
      optionLabel: `options["provincia"]`,
      value: data.provincia?.trim(),
      disabled: !edit,
      onChange: (e) => handleChange('provincia', e.provincia),
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'localidad',
      label: 'Localidad',
      optionValue: 'localidad',
      options: filteredCities,
      optionLabel: `options["displayName"]`,
      value: data.localidad,
      disabled: !edit,
      onChange: (e) => handleChange('localidad', e.localidad),
    },
    {
      class: 'textfield',
      sm: 12,
      xs: 12,
      name: 'domicilio',
      label: 'Dirección',
      value: data.domicilio,
      disabled: !edit,
      onChange: (e) => handleChange('domicilio', e.target.value),
    },
  ]
}
